import React from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { Provider } from 'react-redux'
import { store } from './store/store'
import Layout from './pages/Layout/Layout'
import AdminPage from './pages/Admin/AdminPage';
import LoginPage from './pages/Login/Login';
import HomePage from './pages/Home/HomePage';
import InitPage from './pages/Init/Init';
import DashboardPage from './pages/Dashboard/DashboardPage';


const RouteConfig = () => {

  const PrivateRoute = ({ children, ...rest }) => {
    return (
      <Route
        {...rest}
        render={({ location }) =>
          true ? (
            children
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
        }
      />
    );
  }

  var _haveToken = false;
  var _tokenData = JSON.parse(localStorage.getItem('user'));
  if (_tokenData) {
    _haveToken = true;
  }
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route path="/login">
            <LoginPage />
          </Route>

          <Route path="/" exact={true}>  
          <Redirect
              to={{
                pathname: "/init"
              }}></Redirect>
          </Route>

          <Route path="/init">
            <InitPage></InitPage>
          </Route>

          <PrivateRoute path="/home">
            <Layout route='home' component={<HomePage></HomePage>} />
          </PrivateRoute>
     
          <PrivateRoute path="/admin">
            <Layout route='admin' component={<AdminPage></AdminPage>} />
          </PrivateRoute>
          <PrivateRoute path="/dashboard">
            <Layout route='dashboard' component={<DashboardPage></DashboardPage>} />
          </PrivateRoute>

        </Switch>
      </Router>
    </Provider>

  )
}

export default RouteConfig
